import { render, staticRenderFns } from "./filters-category.vue?vue&type=template&id=494ae00f"
import script from "./filters-category.vue?vue&type=script&lang=js"
export * from "./filters-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports